import { make } from 'vuex-pathify'
import dottie from 'dottie'
import { api } from '@/api'

const state = {
  accounts: []
}

const getters = {
  ...make.getters(state)
}

const mutations = {
  ...make.mutations(state),

  read(state, { accounts }) {
    state.accounts = accounts
  },

  readFailed(state) {
    state.accounts = []
  },

  deletedFromList(state, idsToDelete) {
    state.accounts = state.accounts.filter(
      record => !idsToDelete.includes(record._id)
    )
  },

  deleteFromListFailed() {}
}

const actions = {
  async list({ commit }) {
    try {
      const response = await api.get('/accounts')
      const accounts = dottie.get(response, 'data.accounts', [])
      commit('read', { accounts })
    } catch (e) {
      commit('readFailed')
    }
  },

  async deleteFromList({ commit }, { ids }) {
    try {
      ids.forEach(async id => {
        const response = await api.delete(`/accounts/${id}`)
        if (response.status === 200) commit('deletedFromList', [id])
      })
    } catch (e) {
      commit('deleteFromListFailed')
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
